import { Button } from '@fluentui/react-components';
import { WeatherSunny32Regular, WeatherMoon32Regular } from '@fluentui/react-icons';

interface ThemeToggleProps {
    isDark: boolean;
    onToggle: () => void;
}

/**
 * Theme toggle button component for switching between light and dark modes.
 *
 * Displays a sun icon in dark mode (to switch to light) and a moon icon in light mode (to switch to dark).
 * Follows Microsoft Fluent UI theme management approach using FluentProvider with dynamic theme prop.
 *
 * @param isDark - Current theme state (true = dark mode, false = light mode)
 * @param onToggle - Callback function to toggle theme state
 */
export function ThemeToggle({ isDark, onToggle }: ThemeToggleProps) {
    const icon = isDark ? <WeatherSunny32Regular /> : <WeatherMoon32Regular />;
    const ariaLabel = isDark ? 'Switch to light mode' : 'Switch to dark mode';

    return (
        <Button
            appearance="subtle"
            size="large"
            icon={icon}
            onClick={onToggle}
            aria-label={ariaLabel}
            data-testid="theme-toggle-button"
        />
    );
}
